/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface CreatePlayerRequestContent
 */
export interface CreatePlayerRequestContent {
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    preferredName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    emailAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    cellNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    addressOne?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    postcode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    secondAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    secondCity?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    secondState?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    secondPostcode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    secondCountry?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    driversLicense?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    idType?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    idExpires?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    gender?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    inactive?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    birthday?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    pasDistribution?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    okToMail?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    okToEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    okToCall?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    okToText?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    gamingMarketingOptIn?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    nonGamingMarketingOptIn?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    host?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    pcsoffered?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerRequestContent
     */
    playerType?: string;
}


/**
 * Check if a given object implements the CreatePlayerRequestContent interface.
 */
export function instanceOfCreatePlayerRequestContent(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function CreatePlayerRequestContentFromJSON(json: any): CreatePlayerRequestContent {
    return CreatePlayerRequestContentFromJSONTyped(json, false);
}

export function CreatePlayerRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePlayerRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'title': !exists(json, 'title') ? undefined : json['title'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'preferredName': !exists(json, 'preferredName') ? undefined : json['preferredName'],
        'emailAddress': !exists(json, 'emailAddress') ? undefined : json['emailAddress'],
        'cellNumber': !exists(json, 'cellNumber') ? undefined : json['cellNumber'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'addressOne': !exists(json, 'addressOne') ? undefined : json['addressOne'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'postcode': !exists(json, 'postcode') ? undefined : json['postcode'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'secondAddress': !exists(json, 'secondAddress') ? undefined : json['secondAddress'],
        'secondCity': !exists(json, 'secondCity') ? undefined : json['secondCity'],
        'secondState': !exists(json, 'secondState') ? undefined : json['secondState'],
        'secondPostcode': !exists(json, 'secondPostcode') ? undefined : json['secondPostcode'],
        'secondCountry': !exists(json, 'secondCountry') ? undefined : json['secondCountry'],
        'driversLicense': !exists(json, 'driversLicense') ? undefined : json['driversLicense'],
        'idType': !exists(json, 'idType') ? undefined : json['idType'],
        'idExpires': !exists(json, 'idExpires') ? undefined : json['idExpires'],
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'inactive': !exists(json, 'inactive') ? undefined : json['inactive'],
        'birthday': !exists(json, 'birthday') ? undefined : json['birthday'],
        'pasDistribution': !exists(json, 'pasDistribution') ? undefined : json['pasDistribution'],
        'okToMail': !exists(json, 'okToMail') ? undefined : json['okToMail'],
        'okToEmail': !exists(json, 'okToEmail') ? undefined : json['okToEmail'],
        'okToCall': !exists(json, 'okToCall') ? undefined : json['okToCall'],
        'okToText': !exists(json, 'okToText') ? undefined : json['okToText'],
        'gamingMarketingOptIn': !exists(json, 'gamingMarketingOptIn') ? undefined : json['gamingMarketingOptIn'],
        'nonGamingMarketingOptIn': !exists(json, 'nonGamingMarketingOptIn') ? undefined : json['nonGamingMarketingOptIn'],
        'host': !exists(json, 'host') ? undefined : json['host'],
        'pcsoffered': !exists(json, 'pcsoffered') ? undefined : json['pcsoffered'],
        'playerType': !exists(json, 'playerType') ? undefined : json['playerType'],
    };
}

export function CreatePlayerRequestContentToJSON(value?: CreatePlayerRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'title': value.title,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'preferredName': value.preferredName,
        'emailAddress': value.emailAddress,
        'cellNumber': value.cellNumber,
        'phoneNumber': value.phoneNumber,
        'addressOne': value.addressOne,
        'city': value.city,
        'state': value.state,
        'postcode': value.postcode,
        'country': value.country,
        'secondAddress': value.secondAddress,
        'secondCity': value.secondCity,
        'secondState': value.secondState,
        'secondPostcode': value.secondPostcode,
        'secondCountry': value.secondCountry,
        'driversLicense': value.driversLicense,
        'idType': value.idType,
        'idExpires': value.idExpires,
        'gender': value.gender,
        'inactive': value.inactive,
        'birthday': value.birthday,
        'pasDistribution': value.pasDistribution,
        'okToMail': value.okToMail,
        'okToEmail': value.okToEmail,
        'okToCall': value.okToCall,
        'okToText': value.okToText,
        'gamingMarketingOptIn': value.gamingMarketingOptIn,
        'nonGamingMarketingOptIn': value.nonGamingMarketingOptIn,
        'host': value.host,
        'pcsoffered': value.pcsoffered,
        'playerType': value.playerType,
    };
}

